"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M21.9998 2H1.9961v16.0068h11.002v-2.0009H3.9965V4.0009h16.0029v1.9984h2.0004V2z"
  }), _react.default.createElement("path", {
    d: "M5.9968 6.0017h8.0015v2.0008H5.9968V6.0017zm0 4.0017h5.001v2.0008h-5.001v-2.0008z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9961 11.504c0 1.3359-.5818 2.5359-1.5057 3.3604l1.4763 6.142L20.9799 22l-2.4846-2.0263L16.0106 22l-1.9867-.9936 1.4762-6.142c-.9239-.8245-1.5057-2.0245-1.5057-3.3604 0-2.4863 2.0151-4.5019 4.5009-4.5019 2.4857 0 4.5008 2.0156 4.5008 4.5019zm-4.5008 2.5011c1.3809 0 2.5004-1.1198 2.5004-2.5011 0-1.3813-1.1195-2.501-2.5004-2.501-1.381 0-2.5005 1.1197-2.5005 2.501s1.1195 2.5011 2.5005 2.5011zm-1.2122 2.0008h2.4243l.7099 2.9537-1.922-1.5675-1.9221 1.5675.7099-2.9537z"
  })];
};

exports.default = _default;